import { SVGProps } from "react";

const IconMonitor = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}
        >
            <path
                d="M14.0801 16.2461H3C2.44772 16.2461 2 15.7984 2 15.2461V5C2 4.44772 2.44772 4 3 4H19C19.5523 4 20 4.44772 20 5V9.5464"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M5 13.2468H8.25586"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 10.2473H8.63281"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                x1="6.75"
                y1="19.2422"
                x2="15.25"
                y2="19.2422"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <circle
                cx="15.6859"
                cy="11.7176"
                r="2.24782"
                transform="rotate(-33.812 15.6859 11.7176)"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <circle
                cx="15.7023"
                cy="11.7206"
                r="4.83876"
                transform="rotate(-33.812 15.7023 11.7206)"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M18.7824 19.0268C19.0897 19.4857 19.7109 19.6085 20.1697 19.3012L20.583 19.0244C21.0418 18.7171 21.1647 18.096 20.8574 17.6371L19.2181 15.1894L17.1431 16.5791L18.7824 19.0268Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconMonitor;
